import useIntl from '@/hooks/useIntl';
import { useModel } from '@umijs/max';
import { Space } from 'antd';
import HeaderSearch from '../HeaderSearch';
import Avatar from './AvatarDropdown';
import styles from './index.less';
import SelectLang from './SelectLang';

export type SiderTheme = 'light' | 'dark';

const GlobalHeaderRight: React.FC = () => {
    const { initialState } = useModel('@@initialState');
    const t = useIntl();

    if (!initialState || !initialState.settings) {
        return null;
    }

    const { navTheme, layout } = initialState.settings;
    let className = styles.right;

    if ((navTheme === 'realDark' && layout === 'top') || layout === 'mix') {
        className = `${styles.right}  ${styles.dark}`;
    }

    return (
        <Space className={className}>
            <HeaderSearch
                className={`${styles.action} ${styles.search}`}
                placeholder={t('common.search.here')}
                options={[
                    {
                        label: <a href="#">{t('All Departments')}</a>,
                        value: '1',
                    },
                    {
                        label: <a href="#">{t('Motor Department')}</a>,
                        value: '2',
                    },
                    {
                        label: <a href="#">{t('Property Department')}</a>,
                        value: '3',
                    },
                    {
                        label: <a href="#">{t('Health Department')}</a>,
                        value: '4',
                    },
                ]}
            />
            {/* <span className={styles.action} onClick={() => {}}>
        <QuestionCircleOutlined />
      </span> */}
            <Avatar />
            <SelectLang />
        </Space>
    );
};
export default GlobalHeaderRight;
